import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Paper as MuiPaper, Grid, Typography, Link, Box } from "@mui/material";

import useAxios from "../../hooks/useAxios";

const Paper = styled(MuiPaper)`
  margin: 2px 10px;
  padding: 15px 10px;
`;

const GridContainer = styled(Grid)`
  height: 100%;
  align-items: center;
`;

export default function PoweredBy() {
  const axios = useAxios();
  const [name, setName] = useState("DigiPass");

  useEffect(() => {
    if (sessionStorage.getItem("authToken")) {
      axios({
        url: "/admin/business/get-business-theme",
        customAuthToken: sessionStorage.getItem("authToken"),
        disableError: true,
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setName(response.data.name);
        }
      });
    }
  }, []);

  return (
    <Box sx={{ px: 2, pb: 2 }}>
      <Paper
        elevation={0}
        sx={{
          background: "rgba(255, 255, 255, 0.03)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.05)",
          borderRadius: "16px",
          p: 2,
        }}
      >
        <GridContainer container>
          <Grid item xs>
            <Link
              href="#"
              sx={{
                background: "linear-gradient(to right, #818cf8, #c084fc)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 700,
                textDecoration: "none",
                "&:hover": {
                  opacity: 0.8,
                },
              }}
            >
              Powered By Verismart.ai
            </Link>
          </Grid>

          <Grid item xs>
            <Typography
              variant="subtitle2"
              align="right"
              sx={{ color: "#94a3b8" }}
            >
              © {name} {new Date().getFullYear()}
            </Typography>
          </Grid>
        </GridContainer>
      </Paper>
    </Box>
  );
}
